export default __webpack_public_path__ + "static/media/Prologue_Haven2.30123659.svg";